import { NgModule } from '@angular/core';
import { CoreTailwindService } from '@core/services/tailwind/tailwind.service';

@NgModule({
    providers: [
        CoreTailwindService
    ]
})
export class CoreTailwindConfigModule
{
    /**
     * Constructor
     */
    constructor(private _coreTailwindConfigService: CoreTailwindService)
    {
    }
}
